import { ENUM_DELIVERYMAN_STATUS } from '@/_constants/enums';

export const GET_MOTOBOYS_ONLINE = 'GET_MOTOBOYS_ONLINE';
export const GET_PLACES_OPEN = 'GET_PLACES_OPEN';

export enum ENUM_LEGEND_STATUS {
  PLACE_WITH_DELIVERY_IN_PROGRESS = 'Loja com entrega em andamento',
  PLACE_WITH_DELIVERY_PENDING = 'Loja com entrega pendente',
  DELIVERYMAN_AVAILABLE = 'Entregador disponível',
  DELIVERYMAN_IN_DELIVERY = 'Entregador em rota de entrega',
  DELIVERYMAN_GOING_TO_STORE = 'Entregador dirigindo-se a loja',
}

export enum ENUM_DELIVERY_MODEL_LABELS {
  ALL = 'Todos',
  OWN_DELIVERYMAN = 'Entregador próprio',
  CLOUD_DELIVERYMAN = 'Entregador nuvem',
  OWN_AND_CLOUD_DELIVERYMAN = 'Entregador próprio/nuvem',
  OWN_PLACE = 'Loja próprio',
  CLOUD_PLACE = 'Loja nuvem',
  OWN_AND_CLOUD_PLACE = 'Loja próprio/nuvem',
}

export const LEGEND_STATUS_OPTIONS = [
  {
    key: ENUM_LEGEND_STATUS.PLACE_WITH_DELIVERY_IN_PROGRESS,
    text: ENUM_LEGEND_STATUS.PLACE_WITH_DELIVERY_IN_PROGRESS,
    value: ENUM_LEGEND_STATUS.PLACE_WITH_DELIVERY_IN_PROGRESS,
  },
  {
    key: ENUM_LEGEND_STATUS.PLACE_WITH_DELIVERY_PENDING,
    text: ENUM_LEGEND_STATUS.PLACE_WITH_DELIVERY_PENDING,
    value: ENUM_LEGEND_STATUS.PLACE_WITH_DELIVERY_PENDING,
  },
  {
    key: ENUM_LEGEND_STATUS.DELIVERYMAN_AVAILABLE,
    text: ENUM_LEGEND_STATUS.DELIVERYMAN_AVAILABLE,
    value: ENUM_DELIVERYMAN_STATUS.DISPONIVEL,
  },
  {
    key: ENUM_LEGEND_STATUS.DELIVERYMAN_IN_DELIVERY,
    text: ENUM_LEGEND_STATUS.DELIVERYMAN_IN_DELIVERY,
    value: ENUM_DELIVERYMAN_STATUS.EM_CORRIDA,
  },
  {
    key: ENUM_LEGEND_STATUS.DELIVERYMAN_GOING_TO_STORE,
    text: ENUM_LEGEND_STATUS.DELIVERYMAN_GOING_TO_STORE,
    value: ENUM_DELIVERYMAN_STATUS.ENTREGA_ASSOCIADA,
  },
];

export const DELIVERY_MODEL_OPTIONS = [
  {
    key: ENUM_DELIVERY_MODEL_LABELS.ALL,
    text: ENUM_DELIVERY_MODEL_LABELS.ALL,
    value: ENUM_DELIVERY_MODEL_LABELS.ALL,
  },
  {
    key: ENUM_DELIVERY_MODEL_LABELS.OWN_DELIVERYMAN,
    text: ENUM_DELIVERY_MODEL_LABELS.OWN_DELIVERYMAN,
    value: ENUM_DELIVERY_MODEL_LABELS.OWN_DELIVERYMAN,
  },
  {
    key: ENUM_DELIVERY_MODEL_LABELS.CLOUD_DELIVERYMAN,
    text: ENUM_DELIVERY_MODEL_LABELS.CLOUD_DELIVERYMAN,
    value: ENUM_DELIVERY_MODEL_LABELS.CLOUD_DELIVERYMAN,
  },
  {
    key: ENUM_DELIVERY_MODEL_LABELS.OWN_AND_CLOUD_DELIVERYMAN,
    text: ENUM_DELIVERY_MODEL_LABELS.OWN_AND_CLOUD_DELIVERYMAN,
    value: ENUM_DELIVERY_MODEL_LABELS.OWN_AND_CLOUD_DELIVERYMAN,
  },
  {
    key: ENUM_DELIVERY_MODEL_LABELS.OWN_PLACE,
    text: ENUM_DELIVERY_MODEL_LABELS.OWN_PLACE,
    value: ENUM_DELIVERY_MODEL_LABELS.OWN_PLACE,
  },
  {
    key: ENUM_DELIVERY_MODEL_LABELS.CLOUD_PLACE,
    text: ENUM_DELIVERY_MODEL_LABELS.CLOUD_PLACE,
    value: ENUM_DELIVERY_MODEL_LABELS.CLOUD_PLACE,
  },
  {
    key: ENUM_DELIVERY_MODEL_LABELS.OWN_AND_CLOUD_PLACE,
    text: ENUM_DELIVERY_MODEL_LABELS.OWN_AND_CLOUD_PLACE,
    value: ENUM_DELIVERY_MODEL_LABELS.OWN_AND_CLOUD_PLACE,
  },
];
